module.exports = __webpack_public_path__ + "img/violet_013.549b3508.png";